(() => {
  function buildMarquee() {
    document.querySelectorAll('.announcement-bar:not([data-zayro-marquee-ready])').forEach((bar) => {
      const source = bar.querySelector('.announcement-bar__text');
      const slider = bar.querySelector('.announcement-bar__slider');
      if (!source || !slider) return;

      const text = source.textContent.trim();
      if (!text) return;

      const marquee = document.createElement('div');
      marquee.className = 'zayro-marquee';
      marquee.setAttribute('role', 'region');
      marquee.setAttribute('aria-label', 'Store announcement');
      const track = document.createElement('div');
      track.className = 'zayro-marquee__track';

      for (let groupIndex = 0; groupIndex < 2; groupIndex += 1) {
        const group = document.createElement('div');
        group.className = 'zayro-marquee__group';
        if (groupIndex === 1) group.setAttribute('aria-hidden', 'true');
        for (let i = 0; i < 5; i += 1) {
          const item = document.createElement('span');
          item.className = 'zayro-marquee__item';
          item.append(document.createTextNode(text));
          const spark = document.createElement('span');
          spark.className = 'zayro-marquee__spark';
          spark.setAttribute('aria-hidden', 'true');
          spark.textContent = '✦';
          item.append(spark);
          group.append(item);
        }
        track.append(group);
      }

      marquee.append(track);
      slider.replaceWith(marquee);
      bar.dataset.zayroMarqueeReady = 'true';
    });
  }

  function enableProductCardAddToCart() {
    if (document.documentElement.dataset.zayroAtcReady === 'true') return;
    document.documentElement.dataset.zayroAtcReady = 'true';

    document.addEventListener('submit', async (event) => {
      const form = event.target.closest('.zayro-card-actions form');
      if (!form) return;
      const button = form.querySelector('.zayro-card-atc');
      if (!button || button.disabled) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      const root = window.Shopify?.routes?.root || '/';
      const originalText = button.textContent;
      button.disabled = true;
      button.textContent = 'ADDING...';

      try {
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
          credentials: 'same-origin'
        });
        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(errorData.description || errorData.message || 'Unable to add item to cart');
        }
        button.textContent = 'ADDED ✓';
        window.location.assign(`${root}cart`);
      } catch (error) {
        console.error('Zayro add to cart error:', error);
        button.textContent = originalText;
        button.disabled = false;
        form.submit();
      }
    }, true);
  }

  function addMobileSocialIcons() {
    if (!document.getElementById('zayro-drawer-social-styles')) {
      const style = document.createElement('style');
      style.id = 'zayro-drawer-social-styles';
      style.textContent = `
        .zayro-drawer-socials { display: none; }
        @media screen and (max-width: 749px) {
          .zayro-drawer-socials {
            display: grid;
            grid-template-columns: repeat(4, minmax(0, 1fr));
            margin-top: var(--padding-sm);
            margin-inline-end: var(--padding-xl);
            border-top: 1px solid var(--color-border);
            border-left: 1px solid var(--color-border);
            color: var(--color-foreground);
          }
          .zayro-drawer-socials__item {
            min-height: 58px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-right: 1px solid var(--color-border);
            border-bottom: 1px solid var(--color-border);
            color: inherit;
          }
          .menu-drawer .zayro-drawer-socials__icon { display: block; width: 24px; height: 24px; }
          .menu-drawer__featured-content,
          .menu-drawer__featured-content--childlist { display: none !important; }
        }
      `;
      document.head.append(style);
    }

    document.querySelectorAll('.menu-drawer__utility-links:not([data-zayro-socials-ready])').forEach((utility) => {
      const socials = document.createElement('div');
      socials.className = 'zayro-drawer-socials';
      socials.setAttribute('aria-label', 'Social media');
      socials.innerHTML = `
        <span class="zayro-drawer-socials__item" role="img" aria-label="Instagram"><svg class="zayro-drawer-socials__icon" viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="5" stroke="currentColor" stroke-width="2"/><circle cx="12" cy="12" r="4" stroke="currentColor" stroke-width="2"/><circle cx="17.5" cy="6.5" r="1.2" fill="currentColor"/></svg></span>
        <span class="zayro-drawer-socials__item" role="img" aria-label="Facebook"><svg class="zayro-drawer-socials__icon" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M13.7 21v-8h2.7l.4-3.1h-3.1V7.9c0-.9.3-1.5 1.6-1.5H17V3.6c-.3 0-1.3-.1-2.5-.1-2.5 0-4.2 1.5-4.2 4.3v2.1H7.5V13h2.8v8h3.4Z"/></svg></span>
        <span class="zayro-drawer-socials__item" role="img" aria-label="YouTube"><svg class="zayro-drawer-socials__icon" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M21.6 7.2a3 3 0 0 0-2.1-2.1C17.7 4.6 12 4.6 12 4.6s-5.7 0-7.5.5a3 3 0 0 0-2.1 2.1C1.9 9 1.9 12 1.9 12s0 3 .5 4.8a3 3 0 0 0 2.1 2.1c1.8.5 7.5.5 7.5.5s5.7 0 7.5-.5a3 3 0 0 0 2.1-2.1c.5-1.8.5-4.8.5-4.8s0-3-.5-4.8ZM10 15.3V8.7l5.7 3.3-5.7 3.3Z"/></svg></span>
        <span class="zayro-drawer-socials__item" role="img" aria-label="TikTok"><svg class="zayro-drawer-socials__icon" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M14.2 3c.2 1.5 1.1 2.8 2.4 3.5.8.5 1.7.7 2.4.7v3a8.3 8.3 0 0 1-4.7-1.5v6.2a5.9 5.9 0 1 1-5.1-5.8v3a2.9 2.9 0 1 0 2.1 2.8V3h2.9Z"/></svg></span>
      `;
      utility.append(socials);
      utility.dataset.zayroSocialsReady = 'true';
    });
  }

  const COLOR_MAP = {
    green: '#556b2f',
    'olive green': '#667a3e',
    olive: '#667a3e',
    brown: '#7a4a2f',
    black: '#111111',
    white: '#ffffff',
    silver: '#c7c9cc',
    grey: '#8e9298',
    gray: '#8e9298',
    blue: '#315b8a',
    navy: '#1f3558',
    red: '#b63838',
    gold: '#c7a34b',
    rose: '#c78686',
    beige: '#d8c6a8'
  };

  function resolveColor(name) {
    const normalized = String(name || '').trim().toLowerCase();
    if (COLOR_MAP[normalized]) return COLOR_MAP[normalized];
    if (window.CSS?.supports?.('color', normalized)) return normalized;
    return '#d6d6d6';
  }

  function installSwatchStyles() {
    if (document.getElementById('zayro-color-swatch-styles')) return;
    const style = document.createElement('style');
    style.id = 'zayro-color-swatch-styles';
    style.textContent = `
      .zayro-card-color-swatches {
        display: flex;
        align-items: center;
        gap: 8px;
        min-height: 30px;
        margin-top: 2px;
      }
      .zayro-color-swatch {
        appearance: none;
        border: 0;
        background: transparent;
        padding: 3px;
        margin: 0;
        width: 28px;
        height: 28px;
        border-radius: 50%;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        outline: 1px solid transparent;
        outline-offset: 1px;
        transition: transform 180ms ease, outline-color 180ms ease, box-shadow 180ms ease;
      }
      .zayro-color-swatch:hover { transform: scale(1.1); }
      .zayro-color-swatch.is-active {
        outline-color: currentColor;
        box-shadow: 0 0 0 2px var(--color-background, #fff) inset;
      }
      .zayro-color-swatch__dot,
      .zayro-product-color-dot {
        display: block;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: var(--zayro-color, #d6d6d6);
        border: 1px solid rgba(0,0,0,.22);
        box-shadow: inset 0 0 0 1px rgba(255,255,255,.35);
      }
      .zayro-card-upgraded img {
        transition: opacity 220ms ease, transform 220ms ease;
      }
      .zayro-card-upgraded.zayro-color-changing img:first-of-type {
        opacity: .32;
        transform: scale(.985);
      }
      variant-picker .zayro-product-color-option {
        display: flex;
        align-items: center;
        gap: 10px;
      }
      variant-picker .zayro-product-color-option legend {
        width: 100%;
        margin-bottom: 8px;
      }
      variant-picker .zayro-product-color-label {
        flex: 0 0 34px !important;
        width: 34px !important;
        height: 34px !important;
        min-width: 34px !important;
        min-height: 34px !important;
        padding: 6px !important;
        border-radius: 50% !important;
        overflow: visible !important;
        background: transparent !important;
        border: 0 !important;
        display: inline-flex !important;
        align-items: center;
        justify-content: center;
        transition: transform 180ms ease, box-shadow 180ms ease !important;
      }
      variant-picker .zayro-product-color-label:hover { transform: scale(1.08); }
      variant-picker .zayro-product-color-label .variant-option__button-label__text,
      variant-picker .zayro-product-color-label .variant-option__button-label__pill { display: none !important; }
      variant-picker .zayro-product-color-label:has(input:checked) {
        box-shadow: 0 0 0 2px var(--color-foreground), 0 0 0 4px var(--color-background) !important;
      }
      product-information img {
        transition: opacity 240ms ease, transform 240ms ease;
      }
      product-information.zayro-color-transitioning img {
        opacity: .58;
        transform: scale(.992);
      }
      @media (prefers-reduced-motion: reduce) {
        .zayro-color-swatch,
        .zayro-card-upgraded img,
        variant-picker .zayro-product-color-label,
        product-information img { transition: none !important; }
      }
    `;
    document.head.append(style);
  }

  function paintDots(root = document) {
    root.querySelectorAll('[data-zayro-color-dot]').forEach((dot) => {
      dot.style.setProperty('--zayro-color', resolveColor(dot.dataset.zayroColorDot));
    });
  }

  function updateCardLinks(card, variantId) {
    card.querySelectorAll('a[href]').forEach((link) => {
      try {
        const url = new URL(link.href, window.location.origin);
        if (url.origin !== window.location.origin) return;
        url.searchParams.set('variant', variantId);
        link.href = url.toString();
      } catch (_) {}
    });
  }

  function switchCardColor(button) {
    const card = button.closest('product-card');
    if (!card) return;
    const variantId = button.dataset.variantId;
    const imageUrl = button.dataset.imageUrl;
    if (!variantId) return;

    card.querySelectorAll('[data-zayro-color-swatch]').forEach((swatch) => {
      const active = swatch === button;
      swatch.classList.toggle('is-active', active);
      swatch.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    const variantInput = card.querySelector('.zayro-card-actions input[name="id"]');
    if (variantInput) variantInput.value = variantId;
    updateCardLinks(card, variantId);

    if (imageUrl) {
      const visibleImage =
        card.querySelector('slideshow-slide[aria-hidden="false"] img') ||
        card.querySelector('slideshow-slide:not([hidden]) img') ||
        card.querySelector('.product-card__content img');

      if (visibleImage) {
        card.classList.add('zayro-color-changing');
        window.setTimeout(() => {
          visibleImage.src = imageUrl;
          visibleImage.srcset = imageUrl;
          card.setAttribute('data-featured-media-url', imageUrl);
          requestAnimationFrame(() => card.classList.remove('zayro-color-changing'));
        }, 95);
      }
    }
  }

  function decorateProductPageColorOptions(root = document) {
    const inputs = root.querySelectorAll('variant-picker input[data-option-name="Color"], variant-picker input[data-option-name="Colour"]');
    inputs.forEach((input) => {
      if (input.closest('product-card')) return;
      const fieldset = input.closest('fieldset');
      const label = input.closest('label');
      if (!fieldset || !label) return;
      fieldset.classList.add('zayro-product-color-option');
      label.classList.add('zayro-product-color-label');
      label.title = input.value;
      if (!label.querySelector('.zayro-product-color-dot')) {
        const dot = document.createElement('span');
        dot.className = 'zayro-product-color-dot';
        dot.style.setProperty('--zayro-color', resolveColor(input.value));
        dot.setAttribute('aria-hidden', 'true');
        label.append(dot);
      }
    });
  }

  function enableColorSwatches() {
    installSwatchStyles();
    paintDots();
    decorateProductPageColorOptions();

    if (document.documentElement.dataset.zayroSwatchesReady === 'true') return;
    document.documentElement.dataset.zayroSwatchesReady = 'true';

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-zayro-color-swatch]');
      if (!button) return;
      event.preventDefault();
      event.stopPropagation();
      switchCardColor(button);
    });

    document.addEventListener('change', (event) => {
      const input = event.target.closest('variant-picker input[data-option-name="Color"], variant-picker input[data-option-name="Colour"]');
      if (!input || input.closest('product-card')) return;
      const productInfo = input.closest('product-information') || document.querySelector('product-information');
      if (productInfo) {
        productInfo.classList.remove('zayro-color-transitioning');
        void productInfo.offsetWidth;
        productInfo.classList.add('zayro-color-transitioning');
        window.setTimeout(() => productInfo.classList.remove('zayro-color-transitioning'), 420);
      }
      window.setTimeout(() => decorateProductPageColorOptions(), 120);
      window.setTimeout(() => decorateProductPageColorOptions(), 650);
    });

    const main = document.querySelector('main');
    if (main && !main.dataset.zayroSwatchObserver) {
      const observer = new MutationObserver(() => {
        requestAnimationFrame(() => decorateProductPageColorOptions(main));
      });
      observer.observe(main, { childList: true, subtree: true });
      main.dataset.zayroSwatchObserver = 'true';
    }
  }

  function initializeZayroUpgrades() {
    buildMarquee();
    enableProductCardAddToCart();
    addMobileSocialIcons();
    enableColorSwatches();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeZayroUpgrades, { once: true });
  } else {
    initializeZayroUpgrades();
  }

  document.addEventListener('shopify:section:load', () => {
    buildMarquee();
    addMobileSocialIcons();
    paintDots();
    decorateProductPageColorOptions();
  });
})();
